import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountDebtor } from '../../../../models/account.model';
import { AccountDebtorService } from '../../../../services/accountDebtor.service';
import { HeaderTemplateData } from '../../dialog/dialog-data.interface';



export interface SwitchDebtorAccountDialogData {
   accountDebtorListing:any[];
   header:HeaderTemplateData;
}

interface DebtorAccount {
  accountId:string;
  debtorId:number;
}

@Component({
  selector: 'switch-dialog',
  templateUrl: 'switch-dialog.html',
  styleUrls: ['switch-dialog.scss']
})


export class SwitchDialog implements OnInit {
  result: AccountDebtor[] = [];
  header: HeaderTemplateData;
  currentSelectedDebtorAccount:DebtorAccount;

  constructor(
    public dialogRef: MatDialogRef<SwitchDialog>,
    private debtorAccountService : AccountDebtorService,
    @Inject(MAT_DIALOG_DATA) private _data: SwitchDebtorAccountDialogData
  ) {
    if (this._data != null) {
      this.result=this._data.accountDebtorListing;
      this.header = this._data.header;
      this.currentSelectedDebtorAccount = {
        accountId:this.debtorAccountService.CurrentAccountDebtor.accountId,
        debtorId:this.debtorAccountService.CurrentAccountDebtor.lDebtorId,
      }
    }
  }

  ngOnInit() {
  }

  switchDebtorAccount(){
    //check if select not the current debtor account only will trigger switch else it wont trigger
    if(this.currentSelectedDebtorAccount.accountId != this.debtorAccountService.CurrentAccountDebtor.accountId 
    || this.currentSelectedDebtorAccount.debtorId != this.debtorAccountService.CurrentAccountDebtor.lDebtorId){
      this.debtorAccountService.switchAccountDebtor(this.currentSelectedDebtorAccount.accountId,this.currentSelectedDebtorAccount.debtorId)
    }
  }

  selectDebtorAccount(accountId:string,debtorId:number){
    this.currentSelectedDebtorAccount.accountId=accountId;
    this.currentSelectedDebtorAccount.debtorId=debtorId;
  }


}
